import { render, staticRenderFns } from "./DigitalResourceManagement.vue?vue&type=template&id=19801ef6&"
import script from "./DigitalResourceManagement.vue?vue&type=script&lang=js&"
export * from "./DigitalResourceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports